import reqParm from '@/common/requset/reqParm.js';
import axios from 'axios'
import router from 'vue-router'
import global from '../global/global.js';
import bykApi from '../bykApi';
import store from '../../store/index.js'
import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading
const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}


//贝友Pay后台管理接口
const fGetByPayApiUrl = (apiReqUrl) => {
  //获取请求url
  if (bykApi.smCom.fSmIsEmpty(apiReqUrl)) {
    return global.smPayAdmin.sys.mainSrvUrl + '/smPayMain/api/smPayApi/'
  }
  return apiReqUrl;

};
const fPostToSmPayAdminApi = async (params = {}) => {
  //获取本地存储
  let objByPayAdmin = global.fGetByPayAdmin()

  if (params.API_NAME == 'smPayAdminApi') {
    params.API_USER_PHONE = params.API_USER_PHONE || "160595"
    params.API_USER_ID = params.API_USER_ID || objByPayAdmin.orgUserInfo.userId
  } else {

    //api 手机号
    if (bykApi.smCom.fSmIsEmpty(params.API_USER_PHONE)) {
      params.API_USER_PHONE = objByPayAdmin.orgInfo.orgId
    }
    //api 手机号
    if (bykApi.smCom.fSmIsEmpty(params.API_USER_ID)) {
      params.API_USER_ID = objByPayAdmin.orgUserInfo.userId
    }
  }

  // api token
  if (bykApi.smCom.fSmIsEmpty(params.API_REQ_TOKEN)) {
    params.API_REQ_TOKEN = objByPayAdmin.orgUserInfo.token
  }
  // console.log(reqParm.fReqParam(params))
  // console.log(params)
  startLoading()
	console.log(fGetByPayApiUrl(params.API_REQ_URL))
  let res = await axios.post(fGetByPayApiUrl(params.API_REQ_URL), reqParm.fReqParam(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    } //跨域问题 加上这个
  });
  // console.log(res)
 if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
   endLoading()
   window.location.replace('https://www.sanmipos.com/smpay/partnerAdmin/#/login')
   return {
      data: {
     result: 'fail',
     msg: '请重新登录'
      }
   }
 }
 endLoading()
 // console.log(res)
  return res;
};


export default {
  fPostToSmPayAdminApi, //贝友Pay后台管理接口
}



// WEBPACK FOOTER //
// ./src/common/requset/postApi.js